// mirror on server

export const CURRENCY_EUR = "EUR";
const CURRENCY_SYMBOL_EURO = "€";

function getCurrencyName(currencyCode) {
  const currencyNameLookup = {
    EUR: "Euro",
  };

  return currencyNameLookup[currencyCode] || currencyCode;
}

// https://www.iban.com/currency-codes
const currencyCodeLookup = {
  EUR: CURRENCY_EUR,
};

function getCurrencyCode(currency) {
  return currencyCodeLookup[currency] || currency;
}

const currencySymbolLookup = {
  EUR: CURRENCY_SYMBOL_EURO,
};

function getCurrencySymbol(currencyCode) {
  return currencySymbolLookup[currencyCode] || currencyCode;
}

const CURRENCIES = {
  EUR: {
    key: 1,
    value: CURRENCY_EUR,
    currency: getCurrencyName(CURRENCY_EUR),
    code: getCurrencyCode(CURRENCY_EUR),
    symbol: getCurrencySymbol(CURRENCY_EUR),
    icon: "eur", // https://react.semantic-ui.com/elements/icon/
  },
};

export function getCurrencyProperties(currencyCode) {
  return CURRENCIES[currencyCode] || currencyCode;
}
